module.exports = __webpack_public_path__ + "img/fashion_98.e3a17db3.jpg";